import React from 'react'
import { Collapse } from 'components/common/Collapse'
import { dateService } from 'services/date.service'
import { yearMonthDateFormat } from 'constants/dateFormats'
import { RangeDatePicker } from 'components/common/RangeDatePicker'
import styles from '../index.module.scss'
import useComponentVisible from 'hooks/useComponentVisible'

interface Props {
  label: string
  values: string[]
  onChange: (values: string[]) => void
}

const DateFilter: React.FC<Props> = ({ label, values, onChange }) => {
  const componentVisible = useComponentVisible(false)

  return (
    <Collapse
      header={<h6 className={styles.filterTitle}>{label}</h6>}
      gap="20px"
      hasArrow
      defaultOpen
    >
      <RangeDatePicker
        componentVisible={componentVisible}
        values={values.map((date) => new Date(date))}
        onValuesChange={(values) => {
          onChange(
            values.map((value) =>
              dateService.getDate(value).format(yearMonthDateFormat)
            )
          )
        }}
      />
    </Collapse>
  )
}

export default DateFilter
